var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGolfFlagSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "golf-flag-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.9208 48.4112C27.746 48.4112 34.9002 47.1207 34.9002 45.5288C34.9002 43.937 27.746 42.6465 18.9208 42.6465C10.0956 42.6465 2.94141 43.937 2.94141 45.5288C2.94141 47.1207 10.0956 48.4112 18.9208 48.4112Z",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.4592 1.4707H17.6475V39.5854H20.4592V1.4707Z",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6211 1.77398C23.6211 1.77398 28.4564 0.538682 36.7093 6.07103C44.9623 11.6063 43.324 16.4004 48.777 16.7946C51.7123 16.6004 47.5417 20.2299 43.324 18.571C35.1446 15.3563 32.7358 10.8152 23.6211 15.0122V1.77398Z",
    fill: "#D0300E"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfFlagSvgrepoCom1);
export default __webpack_public_path__ + "static/media/golf-flag-svgrepo-com 1.b01d643f544c3d602401f7d8a606053b.svg";
export { ForwardRef as ReactComponent };